// extracted by mini-css-extract-plugin
export default {"brandPromo":"CE-z","carousel":"DE-z"};